import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0d029858&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import "./App.vue?vue&type=style&index=0&id=0d029858&prod&lang=scss&scoped=true"
/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d029858",
  null
  
)

export default component.exports